import React from 'react';
const DocumentResult = ({ doc, selected, handleSelectDocument }) => {
    var _a;
    let submissionTime = doc.startTime;
    try {
        const date = doc.startTime.endsWith('Z') ? doc.startTime : doc.startTime + 'Z';
        submissionTime = new Date(date).toLocaleString();
    }
    catch (e) {
        console.warn(`Failed to parse submission date: ${doc.startTime}`);
    }
    const documentLinkUrl = `/document/${doc.fileId}`;
    const openSingleDocView = (e) => {
        e.preventDefault();
        window.open(documentLinkUrl, '_blank', 'height=750,width=1100');
    };
    return React.createElement("div", { className: 'document-search-result' },
        React.createElement("div", { className: 'col check-col', onClick: () => handleSelectDocument(doc) },
            React.createElement("input", { id: `line-check-${doc.fileId}`, type: 'checkbox', className: 'input', checked: selected, disabled: doc.txStatus !== 'Completed' })),
        React.createElement("div", { className: 'col doc-col overflow-ellipsis' },
            React.createElement("a", { className: 'link', href: documentLinkUrl, onClick: openSingleDocView }, doc.fileName)),
        React.createElement("div", { className: 'col status-col', title: doc.txStatus }, (_a = doc.txStatus) !== null && _a !== void 0 ? _a : ''),
        React.createElement("div", { className: 'col time-col' }, submissionTime));
};
export default DocumentResult;
